import { axiosInstance } from './axiosInstance'
import { END_POINT_PRODUCT } from './index'
import type { Crew } from '../reduxStore/materials/types'

const BASE = `${END_POINT_PRODUCT}/api/crews`

export const getCrews = () => {
  return axiosInstance.request<Crew[]>({
    method: 'get',
    url: BASE,
  })
}

export const createCrew = (crew: Omit<Crew, 'id' | 'userId' | 'createdDate'>) => {
  return axiosInstance.request<Crew>({
    method: 'post',
    url: BASE,
    data: crew,
  })
}

export const updateCrew = (id: string, crew: Crew) => {
  return axiosInstance.request<Crew>({
    method: 'put',
    url: `${BASE}/${id}`,
    data: crew,
  })
}

export const deleteCrew = (id: string) => {
  return axiosInstance.request<void>({
    method: 'delete',
    url: `${BASE}/${id}`,
  })
}
